import { render, staticRenderFns } from "./VaultManage.vue?vue&type=template&id=72ff5a3f&scoped=true&"
import script from "./VaultManage.vue?vue&type=script&lang=ts&"
export * from "./VaultManage.vue?vue&type=script&lang=ts&"
import style0 from "./VaultManage.vue?vue&type=style&index=0&id=72ff5a3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff5a3f",
  null
  
)

export default component.exports